import SetCognitoContactInfo from '~/pages/auth/onboarding/components/SetCognitoContactInfo';

/**
 * Route component for /register/contact-info.
 *
 * This route collects additional contact information from users who signed up via
 * social login (Google, Facebook, Apple). It expects a `registrationToken` query parameter.
 *
 * @example
 * <SocialContactInfoRoute />
 *
 * @see SetCognitoContactInfo
 */
const SocialContactInfoRoute = () => {
  return <SetCognitoContactInfo />;
};

export default SocialContactInfoRoute;
